export const JURISDICTION = {
    AGCO: 'AGCO',
    GRA: 'GRA',
    MGA: 'MGA',
    UKGC: 'UKGC',
    SGA: 'SGA',
    DGOJ: 'DGOJ',
    GGL: 'GGL'
} as const;
